import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import dateFormat from 'dateformat';
import { MarkupHelpers as Markup } from '../../../../../../helpers';
import { Loader } from '../../../../../common/elements';

class SinglePost extends Component {

    state = {
        pictureUrl: 'https://vignette2.wikia.nocookie.net/naginoasukara/images/8/86/Placeholder_person.png/revision/latest?cb=20130924151342',
    };


    componentDidMount() {
        this.getPicture(this.props.person.id);
    }

    componentWillReceiveProps(nextProps) {
        this.props.person.id !== nextProps.person.id ? this.getPicture(nextProps.person.id) : null;
    }

    getPicture = (personId) => {
        const component = this;
        const url = `https://s3.intouchnetworks.com/getImage.php?id=${personId}`;
        fetch(url)
            .then(response => {
                if (response.ok) {
                    return response.text();
                }
            })
            .then(res => {
                if (res !== undefined) {
                    component.setState({ pictureUrl: res });
                } else {
                    component.setState({ pictureUrl: 'https://vignette2.wikia.nocookie.net/naginoasukara/images/8/86/Placeholder_person.png/revision/latest?cb=20130924151342' })
                }

            })
    }

    render() {
        const { id, content, created_at } = this.props.post;
        const { first_name, last_name, id: person_id } = this.props.person;
        const convertedContent = Markup.escapeHtmlHelper(content);


        if (!this.props.post) {
            return <Loader />;
        }

        return (
            <div id={id} className="col-12 forum-reply-card">
                <div className="inner-reply-card">
                    <Link className="col-12 col-md-2 col-lg-2 user-reply-profile-box" to={`/members/${person_id}`}>
                        <img src={`${this.state.pictureUrl}`} className="img-circle" alt="Img" />
                        <p className="user-name clickable">{first_name} {last_name}</p>
                    </Link>
                    <div className="col-12 col-lg-10 forum-reply">
                        <p className="body-copy" dangerouslySetInnerHTML={{ __html: convertedContent }}></p>
                        <div className="discussion-reply-info-box">
                            {/*<h4 className="body-copy clickable">Reply</h4>*/}
                            <h4 className="body-copy">Posted: {dateFormat(created_at, 'dd/mm/yyyy')}</h4>
                        </div>
                    </div>

                </div>
            </div>
        );
    };
}

SinglePost.propTypes = {
    id: PropTypes.string,
    content: PropTypes.object,
    person: PropTypes.object,
    created_at: PropTypes.string
}

export default SinglePost;



// WEBPACK FOOTER //
// src/client/components/site/features/forums/pages/elements/SinglePost.js